<template>
    <div>
        <AgItem :columnDefs="columnDefs"
                :rowData="rowData"
                :with-tabs="true"
                :with-header="true"
                :with-description="true"
                v-on:sortChanged="sortChanged"
        ></AgItem>
        <Pagination
                :totalNum="totalNum"
                :pageSize="pageSize"
                :sizeChange="sizeChange"
                :currentChange="currentChange"
                :currentPage="page"
        ></Pagination>
        <CustomRatingEditModal
                v-if="editModalDisplayed"
                :company-id="editModalCompanyId"
                @close="closeEditModal"
                @submit="confirmSubmitEdit"
        ></CustomRatingEditModal>
    </div>
</template>

<script>
import {customRatingsApi} from "@/common/api/customRatingsApi";
import {asLocalizedDate, asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";
import AgItem from "@/components/templates/agGrid/AgItem";
import Pagination from "@/components/templates/common/Pagination";
import PaginationParent from "@/components/templates/common/PaginationParent";
import CustomRatingEditModal from "@/components/templates/investor/customRating/CustomRatingEditModal";

export default {
		extends: PaginationParent,
		components: {
			CustomRatingEditModal,
			AgItem,
			Pagination
		},
		props: {
			filters: { type: Array, default: [] }
		},
		data() {
			return {
				columnDefs: [],
				rowData: null,
				sorting: [],
                editModalDisplayed: false,
				editModalCompanyId: null
			};
		},
		beforeMount() {
			this.setColumnDefs();
			this.getList();
		},
		methods: {
			setColumnDefs() {
				this.columnDefs = [
					{
						headerName: this.$t("common.company"),
						minWidth: 200,
						field: "companyName",
						nameType: "companyName",
						idType: "ratedCompanyId",
						cellRendererFramework: "CompanyTem",
						sortable: true
					},
					{
						headerName: this.$t("common.vatId"),
						minWidth: 120,
						field: "vatNumber",
						sortable: true
					},
					{
						headerName: this.$t("common.street"),
						minWidth: 200,
						field: "street",
						sortable: true,
					},
					{
						headerName: this.$t("common.postcode"),
						minWidth: 80,
                        maxWidth:120,
						field: "postCode",
						sortable: true,
					},
					{
						headerName: this.$t("common.city"),
						minWidth: 80,
                        maxWidth:150,
						field: "city",
						sortable: true,
					},
					{
						headerName: this.$t("customRating.table.rating1"),
						// headerClass: "align-right",
						field: "rating1",
						// cellStyle: {'justify-content': 'flex-end'},
						valueFormatter: asMoneyAmount(),
						minWidth: 100,
						maxWidth: 120,
						sortable: true
					},
					{
						headerName: this.$t("customRating.table.rating2"),
						// headerClass: "align-right",
						field: "rating2",
						// cellStyle: {'justify-content': 'flex-end'},
						valueFormatter: asMoneyAmount(),
						minWidth: 100,
						maxWidth: 120,
						sortable: true
					},
					{
						headerName: this.$t("customRating.table.rating3"),
						// headerClass: "align-right",
						field: "rating3",
						// cellStyle: {'justify-content': 'flex-end'},
						valueFormatter: asMoneyAmount(),
						minWidth: 100,
						maxWidth: 120,
						sortable: true
					},
					{
						headerName: this.$t("common.updateDate"),
						field: "lastUpdateTime",
						valueFormatter: asLocalizedDate(),
						minWidth: 100,
						maxWidth: 200,
						sortable: true
					},
					{
						headerName: this.$t("common.actions"),
						cellRendererFramework: "CustomRatingTableOperation",
						cellRendererParams: {
							showEditModal: this.showEditModal
						},
						minWidth: 140,
						maxWidth: 140,
						pinned: "right",
					},
				];
			},
			sortChanged(sortData) {
				this.sorting = sortData;
				this.initPage();
				this.getList();
			},
			getList() {
				let postData = {
					columns: [],
					filters: this.filters || [],
					maxResults: this.maxResults,
					offset: this.offset,
					sorting: this.sorting
				};

				customRatingsApi.inspection.listCustomRatings(postData)
					.then(res => {
						this.setTotalNum(res.recordsTotal);
						this.rowData = res.data;
					})
					.catch(err => {
						this.toast(err);
					});
			},
            showEditModal(companyId) {
				this.editModalDisplayed = true;
				this.editModalCompanyId = companyId;
            },
            closeEditModal() {
				this.editModalDisplayed = false;
				this.editModalCompanyId = null;
            },
			confirmSubmitEdit(data) {
				let option = {
					title: this.$t("customRating.editModal.confirmation.title"),
					msg: this.$t("customRating.editModal.confirmation.msg"),
					confirmFun: this.submitEdit,
					params: data
				};
				this.confirmMeg(option, true);
			},
			submitEdit(data) {
                let customRating = {id: data.id, rating1: data.rating1, rating2:data.rating2, rating3:data.rating3};
				customRatingsApi.operation.saveCustomRating(data.companyId, customRating)
                    .then(() => {
                    	this.closeEditModal();
				        this.toastSuccess();
				        this.getList();
                    })
                    .catch(e => {
						this.toast(e);
                    });
            }
		},
		watch: {
			filters() {
				this.getList();
			}
		}
	};
</script>